import "./RecipeHeader.scss";

interface RecipeHeaderProps {
  name: string;
  teaser?: string;
}

const RecipeHeader = ({ name, teaser }: RecipeHeaderProps) => {
  return (
    <header className="recipe-header">
      <div className="container">
        <div className="recipe-header__top">
          <h1 className="recipe-header__title">{name}</h1>

          {teaser && <p className="recipe-header__teaser">{teaser}</p>}
        </div>
      </div>
    </header>
  );
};

export default RecipeHeader;
